import { createContext } from 'react';

export const SliderContext = createContext({} as any);
export const SliderDispatchContext = createContext({} as any);